// extracted by mini-css-extract-plugin
module.exports = {"container":"MessageAttachment_container__a3GhD","previewContainer":"MessageAttachment_previewContainer__WKw29","name":"MessageAttachment_name__vJVH_"};